import * as React from 'react'
import Audio from 'components/Icon/Post/Audio'
import Image from 'components/Icon/Post/Image'
import Video from 'components/Icon/Post/Video'
import Locked from 'components/Icon/Post/Locked'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'i18n'

type Props = {
  post: any
  onClick: (any) => void
}

const Component: React.FC<Props> = ({ post, onClick }) => {
  const { t } = useTranslation('components')

  return (
    <Thumbnail onClick={onClick}>
      <ResourceIcon resourceType={post.resourceType} width={50} height={50} />
      <Typography variant="h6">
        {t('pages.posts.LockedResource.memberOnly')}
      </Typography>
    </Thumbnail>
  )
}

export default Component

const ResourceIcon = function ({ resourceType, ...props }) {
  switch (resourceType) {
    case 'sound':
      return <Audio {...props} />
    case 'image':
      return <Image {...props} />
    case 'video':
      return <Video {...props} />
    default:
      return <Locked {...props} />
  }
}

const Thumbnail = styled.div`
  background-image: url(/static/images/post/blur_background.png);
  background-repeat: no-repeat;
  background-size: cover;
  height: 200px;
  background-position: center;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
